import { createLogger } from "@mb/common";
import { createAngularSentryAdapter } from "./sentry-angular.adapter";

export const clientLogger = createLogger({
    module: 'client',
    sentryAdapter: createAngularSentryAdapter()
});

export const clientTrace = clientLogger.trace;
export const clientDebug = clientLogger.debug;
export const clientInfo = clientLogger.info;
export const clientWarn = clientLogger.warn;
export const clientError = clientLogger.error;
export const clientFatal = clientLogger.fatal;